import { SortableContext, useSortable } from "@dnd-kit/sortable";
import { useDndContext } from "@dnd-kit/core";
import { CSS } from "@dnd-kit/utilities";
import { useMemo } from "react";
import { TaskCard } from "./TaskCard";
import { GripVertical } from "lucide-react";
import "./BoardColumn.scss";

export function BoardColumn({ column, tasks, isOverlay, refetchTasks, onEditTask }) {
  const tasksIds = useMemo(() => tasks.map((task) => task.id), [tasks]);
  const {
    setNodeRef,
    attributes,
    listeners,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: column.id,
    data: { type: "Column", column },
    attributes: { roleDescription: `Column: ${column.title}` },
  });

  const style = {
    transition,
    transform: CSS.Translate.toString(transform),
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={`board-column ${isOverlay ? "overlay" : isDragging ? "dragging-over" : ""}`}
    >
      <div className="board-column-header">
        <button
          {...attributes}
          {...listeners}
          className="drag-handle"
          aria-label={`Move column: ${column.title}`}
        >
          <GripVertical />
        </button>
        <span className="column-title">{column.title}</span>
      </div>
      <div className="board-column-content">
        <SortableContext items={tasksIds}>
          {tasks.map((task) => (
            <TaskCard key={task.id} task={task} refetchTasks={refetchTasks} onEditTask={onEditTask} />
          ))}
        </SortableContext>
      </div>
    </div>
  );
}

export function BoardContainer({ children }) {
  const dndContext = useDndContext();
  return (
    <div
      className={`board-container ${dndContext.active ? "dragging-active" : ""}`}
    >
      <div className="columns-wrapper">{children}</div>
    </div>
  );
}